const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

/* ============================================================
   LUMENLA – Sticky "In den Warenkorb" (nur Mobile, nur Produktseite)
   ------------------------------------------------------------
   Markup + CSS liegen in layout/theme.liquid (#LumenlaStickyAtc).
   Die Logik steht hier, weil der urspruengliche Inline-Skript in
   theme.liquid den falschen Button suchte
   ('product-form button[type=submit]') und deshalb sofort abbrach.
   Der echte Kauf-Button ist der Set-Builder-CTA (.lum-sb__cta).
   Dieser Block laeuft auf allen Seiten, bricht aber sofort ab,
   wenn #LumenlaStickyAtc nicht existiert (also ausserhalb der PDP).
   ============================================================ */
(function () {
  function initLumenlaStickyAtc() {
    var sticky = document.getElementById('LumenlaStickyAtc');
    if (!sticky || sticky.dataset.lumStickyInit === '1') return;
    sticky.dataset.lumStickyInit = '1';

    var stickyButton = sticky.querySelector('.lumenla-sticky-atc__button');
    var stickyPrice = sticky.querySelector('.lumenla-sticky-atc__meta span');
    var stickyTitle = sticky.querySelector('.lumenla-sticky-atc__title');
    if (!stickyButton) return;

    // Jede Kerze brennt bis zu 60h; Basis fuer den "pro Brennstunde"-Wert.
    var BURN_HOURS = 60;

    // Echter Kauf-Button = Set-Builder-CTA; Fallback auf nativen Dawn-Button.
    function getButton() {
      return document.querySelector('.lum-sb__cta') ||
        document.querySelector('product-form button[type="submit"], .product-form__submit');
    }

    var hasScrolledEnough = false;

    function isCartOpen() {
      return document.querySelector('cart-drawer[open], .drawer.active, .cart-drawer.active');
    }

    // Preis in der Sticky-Leiste mit der aktuellen Set-Auswahl synchron halten.
    function syncPrice(btn) {
      if (!stickyPrice || !btn) return;
      var m = (btn.textContent || '').match(/(\d[\d.,]*\s*€|€\s*\d[\d.,]*)/);
      if (m) stickyPrice.textContent = m[0].replace(/\s+/g, ' ').trim();
    }

    // Titel = gewaehlte Set-Option (z.B. "2er-Set"), bei "Einzeln" der Produktname.
    function syncTitle() {
      if (!stickyTitle) return;
      var onCard = document.querySelector('.lum-sb__card.is-on');
      if (!onCard) return;
      var nameEl = onCard.querySelector('.lum-sb__name');
      var baseEl = onCard.querySelector('.lum-sb__base');
      var name = nameEl ? nameEl.textContent.trim() : '';
      var base = baseEl ? baseEl.textContent.trim() : '';
      if (name && !/einzeln/i.test(name)) {
        stickyTitle.textContent = name;
      } else if (base) {
        stickyTitle.textContent = base;
      }
    }

    // "pro Brennstunde"-Badges korrekt aus der Set-Auswahl berechnen.
    // Wert = Gesamtpreis / (Anzahl Kerzen * Brenndauer je Kerze). Betrifft beide
    // Badges: die grosse neben dem Preis (.lumenla-price-badge) und die im Sticky.
    function parseEuro(txt) {
      var m = (txt || '').match(/(\d[\d.]*),(\d{2})/);
      if (m) return parseFloat(m[1].replace(/\./g, '') + '.' + m[2]);
      var m2 = (txt || '').match(/(\d+(?:[.,]\d+)?)/);
      return m2 ? parseFloat(m2[1].replace(',', '.')) : null;
    }
    function setCount() {
      var onCard = document.querySelector('.lum-sb__card.is-on');
      if (!onCard) return 1;

      // data-n ist die verbindliche Quelle der Set-Groesse (Teil des
      // eingefrorenen Bundle-Contracts) und wird zuerst gelesen.
      // Vorher wurde nur die Zahl aus .lum-sb__name geparst — die gibt es im
      // Set-Builder v2 nicht. setCount() fiel dort auf 1 zurueck, und die
      // Kaufleiste rechnete den Set-Preis auf eine einzige Kerze um:
      // 71,70 EUR / (1 x 60 h) = 1,19 EUR/h statt 0,39 EUR/h.
      var attr = onCard.getAttribute('data-n');
      if (attr && !isNaN(parseInt(attr, 10))) return parseInt(attr, 10);

      var nameEl = onCard.querySelector('.lum-sb__name');
      var d = (nameEl ? nameEl.textContent : '').match(/(\d+)/);
      return d ? parseInt(d[1], 10) : 1;
    }
    function fmtEuro(v) {
      var cents = Math.floor(v * 100 + 0.0001);
      // Schreibweise wie in snippets/price.liquid: „0,44€", ohne Leerzeichen.
      return Math.floor(cents / 100) + ',' + String(cents % 100).padStart(2, '0') + '€';
    }
    function syncBadge(btn) {
      var total = parseEuro(btn ? btn.textContent : '');
      if (total == null || !isFinite(total)) return;
      var val = fmtEuro(total / (setCount() * BURN_HOURS));
      var sb = sticky.querySelector('.lumenla-sticky-atc__badge');
      if (sb) sb.textContent = 'Nur ' + val + ' / h';
      var pb = document.querySelector('.lumenla-price-badge');
      if (pb) pb.textContent = 'Nur ' + val + ' pro Brennstunde';
    }

    function updateSticky() {
      var btn = getButton();
      if (!btn) { sticky.classList.remove('is-visible'); return; }

      var rect = btn.getBoundingClientRect();
      var buttonVisible = rect.top < window.innerHeight && rect.bottom > 0;

      if (window.scrollY > 350) hasScrolledEnough = true;

      if (hasScrolledEnough && !buttonVisible && !isCartOpen()) {
        sticky.classList.add('is-visible');
      } else {
        sticky.classList.remove('is-visible');
      }

      syncPrice(btn);
      syncTitle();
      syncBadge(btn);
    }

    window.addEventListener('scroll', updateSticky, { passive: true });
    window.addEventListener('resize', updateSticky);
    document.addEventListener('shopify:section:load', updateSticky);

    stickyButton.addEventListener('click', function () {
      var btn = getButton();
      if (btn) btn.click();

      sticky.classList.remove('is-visible');
      stickyButton.classList.add('is-added');
      stickyButton.textContent = '✓ Hinzugefügt';

      setTimeout(function () {
        stickyButton.classList.remove('is-added');
        stickyButton.textContent = 'In den Warenkorb';
        updateSticky();
      }, 1600);
    });

    setInterval(updateSticky, 500);
    updateSticky();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLumenlaStickyAtc);
  } else {
    initLumenlaStickyAtc();
  }
})();
